import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph,
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import AgentContactDetailsInputForm from '../../components/ContactDetails/AgentContactDetailsInputForm'
import { useState } from 'react';
import {GetProviceCodeFromName, replaceUrlParams, ValidateString} from '../../app/utils'
import {collectorDetailsSelect} from '../../redux/selector/collectorDetailsSelector'
import Navigation from '../Navigation';
import {
    APPLICATION_MODE_RENEW,
    VIEW_MODE_REGULAR,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    ROUTE_PATH
} from '../../app/constants'
import { VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { setCurrentAgentPersonDetails } from '../../redux/slice/additionalApplicationsSlice';

const CollectorDetails = (props) => {

    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params

    const [showValidationError, setShowValidationError] = useState(false)
    
    const viewMode = props.viewMode ? 
            props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR)
    // const [viewMode,setViewMode] = useState(viewM)

    const {applicantDetails} = props.collectorDetails
     
    const collectorDetails = props.collectorDetails[applicationType] ? 
                    props.collectorDetails[applicationType] : 
                        props.collectorDetails

    let defaultCollectorDetails = {
        firstName : "",
        lastName : "",
        phoneNumber:"",
        email:"",
        addressData : {
            address1:"",
            cityName : "",
            stateName : "",
            postalCode : ""
        }
    }

    const [updatedCollecorDetails, setUpdatedCollectorDetails] = useState(applicantDetails 
                                                                ? applicantDetails 
                                                                : defaultCollectorDetails)

    const validateData = () => { 
        //updatedCollecorDetails
        if (ValidateString(updatedCollecorDetails.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(updatedCollecorDetails.lastName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(updatedCollecorDetails.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(updatedCollecorDetails.email, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(!updatedCollecorDetails.addressData)
            return false
        else if(ValidateString(updatedCollecorDetails.addressData.address1, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(updatedCollecorDetails.addressData.cityName, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(updatedCollecorDetails.addressData.stateName, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(GetProviceCodeFromName(updatedCollecorDetails.addressData.stateName), VALIDATION_TYPE.CANADA_PROVINCE_CODE) !== VALIDATION_ERROR.NO_ERROR) 
            return false
        else if(ValidateString(updatedCollecorDetails.addressData.postalCode, VALIDATION_TYPE.CANADA_POSTAL_CODE) !== VALIDATION_ERROR.NO_ERROR)
            return false    
        
        return true
    }

    const onCollectorDetailsChange = (updatedDetail) => {
        let udate = Object.assign({}, updatedCollecorDetails, updatedDetail)
        setUpdatedCollectorDetails(udate)
    }

    const handleSaveAndNext = () => {

        dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                let nextUrl = collectorDetails.navigation.next

                if(props.collectorDetails.applicantCriminalHistoryData
                    && Array.isArray(props.collectorDetails.applicantCriminalHistoryData)
                    && props.collectorDetails.applicantCriminalHistoryData.length > 0) { 
                        nextUrl = ROUTE_PATH.CRIMINAL_HISTORY_DETAILS
                    }
                dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
            })
            .catch((error) => {
                console.error(error.message)           
            })
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> 
            }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
            <>
                <TopNavigationBar {...props} />
                <div className="row bottomMarginMedium">
                    <div className="col-lg-8">
                        <Header 
                            id="collector-details-header"
                            header={collectorDetails.header} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <Paragraph 
                            id="collector-details-text" 
                            text={collectorDetails.text} />
                    </div>
                </div>
            </>
            }
            <div className="row">
                <div className="col-lg-8">
                    <AgentContactDetailsInputForm 
                        id={"collector-details-form"} 
                        withAddress={true}
                        onInputChange={onCollectorDetailsChange} 
                        showValidationError={showValidationError}
                        preloadInput={updatedCollecorDetails} />
                </div>
            </div>
            <div className="row">
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                    <div className="col-lg-8">
                        <Button 
                            id={"business-contact-save-next"}
                            text={"Save"}
                            onClick={() => {
                                if(!validateData()) { 
                                    setShowValidationError(true)
                                    return
                                }

                                setShowValidationError(false)

                                // dispatch(setCollectorDetails(updatedCollecorDetails))
                                dispatch(setCurrentAgentPersonDetails(updatedCollecorDetails))
                                if(props.onEditSave)
                                    props.onEditSave()
                            }}
                            buttonType={"regular_primary"}
                        />
                    </div>
                }
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
                <>
                    <div className="col-lg-8">
                        <Button
                            id="collection-details-save-next-button"
                            buttonType={"regular_primary"}
                            text={"Save and next"}
                            onClick={() => {
                                if(!validateData()) { 
                                    setShowValidationError(true)
                                    return
                                }
                                setShowValidationError(false)
                                // dispatch(setCollectorDetails(updatedCollecorDetails))
                                dispatch(setCurrentAgentPersonDetails(updatedCollecorDetails))
                                //dispatch(push(replaceUrlParams(collectorDetails.navigation.next,applicationType, applicationMode)))
                                handleSaveAndNext()
                            }}
                        />
                    </div>
                </>
                }
            </div>
        </div>
        </>
    )
}

export default connect(collectorDetailsSelect)(CollectorDetails)